import { Dialog, DialogContent } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { dialogService } from '../../services/DialogService'
import { TablePicker } from './TablePicker'
import { ValuePicker } from './ValuePicker'

export const PickerDialog: React.FC = observer(() => {
	const dialog = dialogService.dialog

	return (
		<Dialog
			open={dialog !== undefined}
			onClose={() => dialogService.selectOption()}
		>
			<DialogContent>
				{dialog?.dialog.type === 'tableSelection' && (
					<TablePicker
						configuration={dialog?.dialog}
						onClose={(v) => dialogService.selectOption(v)}
					/>
				)}
				{dialog?.dialog.type === 'valueSelection' && (
					<ValuePicker
						configuration={dialog?.dialog}
						onClose={(v) => dialogService.selectOption(v)}
					/>
				)}
			</DialogContent>
		</Dialog>
	)
})
